import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d549bc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-view" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate" }, "Users", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_6 = { class: "dt-container" }
const _hoisted_7 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "You haven't added any users yet.", -1))
const _hoisted_9 = { class: "inventory-table__actions d-sm-flex align-items-end my-3" }
const _hoisted_10 = { class: "mt-4 mb-2 mt-sm-0 mb-sm-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Filter Users By:", -1))
const _hoisted_12 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isAdmin && !_ctx.isSSOOrg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onNewUser
              }, {
                default: _withCtx(() => [
                  _createTextVNode("New User")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.canAddUsers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: _ctx.tierLimitReachedMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.loading && !_ctx.usersWithoutMe)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_router_link, {
              class: "mt-3 d-inline-block",
              to: { path: '/users/new'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "px-5 py-3",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add Your First User")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", null, [
              _createTextVNode("Employees and other general users who want to share their screens do not need to be added as a user. Accounts added here are meant for people who will be managing your Ditto account. You can manage your account "),
              _createVNode(_component_el_button, {
                onClick: _ctx.onMyUser,
                type: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("here")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createTextVNode(".")
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_el_select, {
                  clearable: "",
                  modelValue: _ctx.userRoleFilter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userRoleFilter) = $event)),
                  placeholder: "All Roles"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("All Users")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "User",
                      value: "user"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Admin",
                      value: "admin"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_el_input, {
                placeholder: "Search Users",
                modelValue: _ctx.userSearch,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userSearch) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_el_table, {
              data: _ctx.filteredUsers,
              ref: "usersTable",
              onRowDblclick: _ctx.handleCurrentChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Name",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_router_link, {
                      to: `/users/${scope.row.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.name) + " " + _toDisplayString(scope.row.isSSOGenerated ? '(SSO)' : ''), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "email",
                  label: "Email",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "roleObject.name",
                  label: "Role",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_Icon, {
                      class: "me-1 role-icon",
                      style: _normalizeStyle({ fill: scope.row.roleObject.color }),
                      icon: scope.row.roleObject.name === 'Admin' ? _ctx.mdiShieldStar : _ctx.mdiShieldLock
                    }, null, 8, ["style", "icon"]),
                    _createVNode(_component_router_link, {
                      to: `/roles/${scope.row.roleObject.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.roleObject.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  "class-name": "el-table-row__delete"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      class: "el-table-row__delete-button",
                      type: "danger",
                      id: scope.row.id,
                      onClick: ($event: any) => (_ctx.onDelete(scope.row)),
                      circle: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("svg", _hoisted_12, [
                          _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_13)
                        ]))
                      ]),
                      _: 2
                    }, 1032, ["id", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "onRowDblclick"])
          ], 64))
    ]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showTierDialog) = $event)),
      isCallout: false,
      isLimit: true,
      message: _ctx.tierLimitReachedMessage,
      onModalClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTierDialog = false))
    }, null, 8, ["modelValue", "message"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}